module.exports = __webpack_public_path__ + "img/Skilled Communicator.05bf8999.png";